import { validate } from "../../helpers/validate.js";
import { attributesFlexSchema } from "./attributes.js";
import { html } from "../../helpers/html-template.js";
const scalarFlex = {
  name: "flex",
  tagName: "flex",
  tiptapName: "",
  attributeTransform: (_, attributes) => {
    return validate(attributesFlexSchema, {
      row: Boolean(attributes.row),
      column: Boolean(attributes.column),
      grow: Number(attributes.grow),
      align: attributes.align,
      justify: attributes.justify
    });
  },
  render: async () => {
    return html`
    <div class="flex">
      <ssg-children></ssg-children>
    </div>`;
  }
};
export {
  scalarFlex
};
//# sourceMappingURL=index.js.map
